import { render } from "./imgBox.vue?vue&type=template&id=8b14b4f8&scoped=true"
import script from "./imgBox.vue?vue&type=script&lang=js"
export * from "./imgBox.vue?vue&type=script&lang=js"

import "./imgBox.vue?vue&type=style&index=0&id=8b14b4f8&lang=scss&scoped=true"

import exportComponent from "/Users/cw/Desktop/BME/screen_project_315/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8b14b4f8"]])

export default __exports__